import React from 'react'

function Main({ children, className = '' }) {
  return <main className={`space-y-12 pb-8 ${className}`}>{children}</main>
}

export default Main
